module.exports = "/assets/img/gxjsqy.7cf87e0f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/index/img/gxjsqy.png
// module id = 13
// module chunks = 1